import { HttpClient } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { environment } from "projects/shared/environments/environment";
import { Observable } from 'rxjs';
import { ActivitiesForm, ActivityLogRes } from "../interfaces/activities";

@Injectable({
  providedIn: 'root'
})
export class ActivitiesService {

  http = inject(HttpClient);


  getActivityLog(page: number, limit: number, data?: ActivitiesForm): Observable<ActivityLogRes> {
    let optionalParams = [`?page=${page}&limit=${limit}`];
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        // Type-safe access with type assertion
        const value = data[key as keyof typeof data];
        if ( value ) optionalParams.push(`&${key}=${value}`);
      }
    }
    return this.http.get<ActivityLogRes>(`${environment.apiUrl}activity-logs${optionalParams.join('').split(',').toString()}`);
  }

}